export const FETCH_ASSETTRANSACTIONS_BEGIN = "FETCH_ASSETTRANSACTIONS_BEGIN";
export const FETCH_ASSETTRANSACTIONS_SUCCESS = "FETCH_ASSETTRANSACTIONS_SUCCESS";
export const FETCH_ASSETTRANSACTIONS_FAILURE = "FETCH_ASSETTRANSACTIONS_FAILURE";

export const FETCH_TRANSACTIONSMENULIST_BEGIN = "FETCH_TRANSACTIONSMENULIST_BEGIN";
export const FETCH_TRANSACTIONSMENULIST_SUCCESS = "FETCH_TRANSACTIONSMENULIST_SUCCESS";
export const FETCH_TRANSACTIONSMENULIST_FAILURE = "FETCH_TRANSACTIONSMENULIST_FAILURE";